import { useUBL } from '@common/log-manager';

export const useCategoryUBL = () => {
  const sendUBL = useUBL();

  const clickCategoryItem = (category_id: string) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'store_info',
      object_type: 'category',
      object_id: category_id,
    });
  };

  return {
    clickCategoryItem,
  };
};
